// Module
var code = " <gh-page layout=\"catalog\"> <gh-page-content> <gh-page-error icon=\"gh:help-outline\" title=\"{{'lbl_page_404_text' | translate}}\" info=\"{{'lbl_page_404_error' | translate}}\"></gh-page-error> </gh-page-content> </gh-page>";
// Exports
module.exports = code;